import {defaultCountry, defaultPhoneCode} from './default';


export class Contact {
    constructor(contact) {
        this._id = '';
        this.contact_id = '';
        this.status_code = '';
        this.contact_type = '';
        this.contact_title = '';
        this.other_contact_title = '';
        this.contact_job_title = '';
        this.contact_first_name = '';
        this.contact_second_name = '';
        this.contact_last_name = '';
        /********* Address Part *****************/
        this.address_finder = '';
        this.zip_code = '';
        this.last_4_zip = '';
        this.flat_name = '';
        this.house_name = '';
        this.house_number = '';
        this.street_line_1 = '';
        this.street_line_2 = '';
        this.street_line_3 = '';
        this.locality = '';
        this.city = '';
        this.county_code = '';   //county or state
        this.province = '';
        this.country_code = defaultCountry;
        this.date_from = '';
        this.date_to = '';
        this.date_to_limit = '';
        this.edit_address = false; //allows the user to see the full address fields
        this.allow_manual_edit = false; //allows the user to edit address if postcode search fails
        this.search_postcode = false; //tells user to do a  postcode search to get the full address fields
        //this.state_code = '';
        this.street_number = '';
        this.floor = '';
        this.suite_apart_number = '';
        this.address_ownership_type = '';
        this.fax_number = '';
        this.email_address = '';
        this.telephone_extension = '';
        this.telephone_number = '';
        this.alternative_phone_number = '';
        this.home_telephone_number = '';
        this.ent_telephone_code = defaultPhoneCode;
        this.ent_alternative_phone_code = defaultPhoneCode;
        this.ent_fax_code = defaultPhoneCode;
        this.rented_since = '';
        this.lease_expire = '';
        this.premises_rented_flag = '';
        this.web_address = '';
        this.bill_to = '';
        this.ship_to = '';
        this.shipping_method = '';
        if (!!contact) {
            this.setContactData(contact);
        }
    }

    setContactData(contact) {
        let business_data_keys = Object.keys(contact);
        business_data_keys.map(f => {
            //TODO this is a fix to enforce the alliance values set in the default for all contacts we have saved without saving the right country_code for Ireland.
            // we can remove this fix before going to UAT.
            // if (f === 'country_code') {
            //     this[f] = contact[f] === defaultCountry ? contact[f] : defaultCountry;
            // } else {
                this[f] =!!contact[f] ? contact[f] : '';
            // }
        });
    }

    setContactType(contact_type) {
        this.contact_type = contact_type;
        return this;
    }
}
